import React, { useEffect } from "react";
import Sidebar from "./components/sidebar";
import Home from "./components/Home";
import CV from "./components/cv";
import Projects from "./components/projekte";
import Footer from "./components/footer";
import { API_BASE_URL, authHeaders } from "./api";


function App() {

    useEffect(() => {

        const checkLogin = async () => {

            const sessionData = localStorage.getItem("session");

            console.log("Session Data:", sessionData);



            if (!sessionData) {
                window.location.href = "/";
                return;
            }



            let session;

            try {
                session = JSON.parse(sessionData);
            } catch (err) {
                console.error("Session JSON kaputt:", err);
                localStorage.clear();
                window.location.href = "/";
                return;
            }


            if (!session.password) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }



            try {

                const response = await fetch(`${API_BASE_URL}/api/auth`, {
                    method: "GET",
                    headers: authHeaders()
                });

                console.log("Auth Response Status:", response.status);
                console.log("Auth Response:", response);

                const data = await response.json();

                if (!data.valid) {
                    console.error("Token ungültig");
                    localStorage.clear();
                    window.location.href = "/";
                }

            } catch (err) {
                console.error(err);
            }

        };

        checkLogin();

    }, []);

    return (
        <React.Fragment>
            <Sidebar />
            <div className="feat" id="feat">
                <Home />
                <CV />
                <Projects />

            </div>
            <Footer />
        </React.Fragment>
    );
}

export default App;
